<template>
  <v-footer
    id="home-footer"
    color="grey darken-4"
    dark
    min-height="72"
  >
    <v-container>
      <v-row>
        <v-col
          class="text-center"
          cols="12"
          md="12"
        >
          Copyright &copy; {{ year }} Enterat Consulting, SL
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <cookie-law theme="blood-orange--rounded" />
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  import CookieLaw from 'vue-cookie-law'

  export default {
    name: 'HomeFooter',

    components: {
      CookieLaw,
    },

    data () {
      return {
        year: new Date().getFullYear(),
      }
    },
  }
</script>

<style lang="sass">
  #home-footer a
    text-decoration: none
</style>
